import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from "@angular/router";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
// import { isLoggedIn } from "../auth/store/auth.selectors";
import {AppState} from "../store/app.state";
import {isAuthenticated, status} from "../store/auth/auth.selector";



@Injectable({ providedIn: "root" })
export class IsUserAuthorized implements CanActivateChild, CanActivate {
  constructor(private store: Store<AppState>, private router: Router) {}

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {


    return this.store.pipe(
      select(status),
      map((status) => {

        if (status !== 'AUTHENTICATED' && status !== 'CHECKING') {
          void this.router.navigateByUrl("/auth/welcome");
        }
        return status === 'AUTHENTICATED';
      }),

    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {


    return this.store.pipe(
      select(status),
      map((status) => {

        if (status === 'AUTHENTICATED' || status === 'CHECKING' || status === 'INITIAL') {
          return true;
        }


        if (status === 'UNAUTHENTICATED') {
          void this.router.navigateByUrl("/auth/welcome");
          return false;
        }

          return true; //status === 'AUTHENTICATED';
      }),
    );
  }
}
